module.exports = __webpack_public_path__ + "img/cols1-LF.6abfb94c.png";